import { featureFlagKeySchema } from "@redotech/feature-flags-model/schema";
import * as z from "zod";

// Accept retired flag keys long enough for stale merchant app bundles to
// refresh without turning features off or failing RPC input validation.
export const deprecatedAlwaysOnFeatureFlagKeys = [
  "analytics-csv-export",
  "bulk-return-actions",
  "disable-old-customer-portal-setting",
  "enable-portal-builder-setting",
  "portal-builder-migrated",
  "returns-processing-voice-notes",
  "support-helpdesk-v-2",
] as const;
export type DeprecatedAlwaysOnFeatureFlagKey =
  (typeof deprecatedAlwaysOnFeatureFlagKeys)[number];

export const getFeatureFlag = {
  name: "getFeatureFlag" as const,
  input: z.object({
    flagKey: z.union([
      featureFlagKeySchema,
      z.enum(deprecatedAlwaysOnFeatureFlagKeys),
    ]),
    defaultValue: z.boolean().nullish(),
  }),
  output: z.object({ enabled: z.boolean() }),
};
